<template>
  <div>
    <vs-popup
      classContent="popup-example"
      :title="fetchtoSentenceCase()"
      :active.sync="assignOpen"
    >
      <vs-row>
        <vs-col vs-w="12" class="mb-4">
          <label>{{formType}} Name</label>
          <vs-input
            v-model="couseWorkPayload.title"
            v-validate="'required'"
            class="w-full"
            icon-pack="feather"
            icon="icon-edit"
            icon-after
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-w="12" class="mb-4">
          <div style="width: 190px">
            <vs-checkbox v-model="couseWorkPayload.has_deadline"
              >Deadline required</vs-checkbox
            >
          </div>
          <div
            style="width: calc(100% - 190px)"
            v-if="couseWorkPayload.has_deadline"
          >
            <flat-pickr
              v-model="couseWorkPayload.deadline"
              class="w-full my-2"
              :config="couseWorkPayload.deadline?{'minDate':couseWorkPayload.deadline?$moment(couseWorkPayload.deadline).format('YYYY-MM-DD'):'today','enableTime': true}:{'enableTime': true, 'minDate':'today'}"
              name="start_date"
              data-vv-name="start_date"
              v-validate="'required'"
            ></flat-pickr>
          </div>
        </vs-col>
        <vs-col vs-w="12" v-if="formName!='Exam' && couseWorkPayload.has_deadline">
          <vs-checkbox v-model="couseWorkPayload.has_submit_after_deadline"
            >Allow coursework to be submitted after deadline</vs-checkbox
          >
        </vs-col>
      </vs-row>
      <vs-divider />
      <vs-row>
        <vs-col vs-w="12" class="mb-4">
          <vs-input
          @keyup="searchFun"
          v-model="filterPayload.name"
            class="w-full"
            type="text"
            placeholder="Search Student Name"
          />
        </vs-col>
        <vs-col vs-w="12">
          <h6 class="mb-2">Filter Students by:</h6>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="p-1">
          <label>Subject</label>
          <v-select
          multiple
          :reduce="option=> option.id"
            @input="fetchStudentList"
            v-model="filterPayload.subject_id"
            label="subject_name"
            class="w-full h-full"
            placeholder="Filter Subject"
            :options="subjectlist"
            :clearable="false"
          ></v-select>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="p-1">
          <label>Course</label>
          <v-select
           @input="fetchStudentList"
            placeholder="Filter Course"
            v-model="filterPayload.course_id"
            :options="courseList"
            :reduce="(course) => course.id"
            label="name"
            @open="onOpen"
            @close="onClose"
          >
            <template #list-footer>
              <li ref="load" class="loader" v-show="course_list_meta.has_next">
                Loading more courses...
              </li>
            </template>
          </v-select>
        </vs-col>
        <vs-col vs-lg="4" vs-sm="12" class="p-1">
          <label>Teacher</label>
          <v-select
          :reduce="option=> option.id"
          @input="fetchStudentList"
          v-model="filterPayload.user_id"
            :getOptionLabel="(item) => `${item.first_name} ${item.last_name}`"
            class="w-full h-full"
            placeholder="Filter Teacher"
             @open="onOpenTeacher"
            @close="onCloseTeacher"
            :options="teacherList"
            @search="funSearch"
          >
            <template v-slot:selected-option="teacherList">
              <img
                v-if="teacherList.picture"
                class="person-img rounded-full"
                :src="teacherList.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ teacherList.first_name }}
              {{ teacherList.last_name }}
            </template>
            <template v-slot:option="teacherList">
              <img
                v-if="teacherList.picture"
                class="person-img rounded-full"
                :src="teacherList.picture"
              />
              <img
                v-else
                class="person-img rounded-full"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              {{ teacherList.first_name }}
              {{ teacherList.last_name }}
            </template>
              <template #list-footer>
              <li ref="loadTeacher" class="loader" v-show="teacher_meta.has_next">
                Loading more teacher...
              </li>
            </template>
          </v-select>
        </vs-col>

        <vs-divider />
        <div class="w-full" v-if="selectedStudents.length > 0">
          <h6 class="mb-4">Selected Students :</h6>
          <div class="flex flex-wrap mb-4">
            <div
              class="text-center mr-1"
              v-for="(selectedUser, index2) in selectedStudents"
              :key="index2"
            >
              <div class="selected-names" style="width: 30px; height: 30px">
                <img
                  v-if="selectedUser.picture"
                  class="person-img rounded-full shadow-md block"
                  :src="selectedUser.picture"
                />
                <img
                  v-else
                  class="person-img rounded-full shadow-md block"
                  src="@/assets/images/pages/user-circle-solid.svg"
                />
                <span
                  @click="closeSelectedUser2(index2)"
                  style="width: 15px; height: 15px; font-size: 12px"
                  class="close"
                  >&times;</span
                >
              </div>
              <p class="name-selected">
                {{ selectedUser.first_name }} {{ selectedUser.last_name }}
              </p>
            </div>
          </div>
          <vs-divider />
        </div>
        <h6 class="w-full mb-4">Select Student</h6>
        <div
          style="max-height: calc(100vh - 350px); overflow: auto"
          class="vertical_scrollbar w-full p-2 relative"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <vs-table
            class="checkbox_removed_vstable cstm_vuexy_table w-full"
            multiple
            v-model="selectedStudents"
            :data="studentlist"
          >
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="avatar_name_td" :data="data[indextr].first_name">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                  <span>
                    {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </span>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </vs-row>
      <vs-button class="block ml-auto mt-4" @click="convertToCourseWork">Proceed</vs-button>
    </vs-popup>
  </div>
</template>
<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { createCourseWork } from '@/api/assignment-question'
import { fetchUserClient } from '@/api/task-project.js'
import { shortCourseList } from '@/api/admission'
import vSelect from 'vue-select'
export default {
  components: {
    vSelect,
    flatPickr
  },
  data () {
    return {
      pageLimitSet: 20,
      assignOpen:false,
      configdeadlineDate: {
        enableTime: true,
        minDate:new Date()
      },
      meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      teacher_meta: {
        page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      subjectlist: [],
      teacherList: [],
      studentlist: [],
      selectedStudents: [],
      courseList: [],
      filterPayload: {
        course_id: null,
        subject_id: [],
        user_id:'',
        name: ''
      },
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      customer_id: '',
      observerCourse: new IntersectionObserver(this.loadMoreCourses),
      observer: new IntersectionObserver(this.loadMoreTeacher),
      couseWorkPayload: {
        user_type: 2,
        title: '',
        has_deadline: false,
        has_submit_after_deadline: false,
        deadline: '',
        assignment_type: this.dataObj.assignment_type
      },
      has_all_subject:false,
      formType:'',
      name:''
    }
  },
  props: {
    formName: {
      type: String
    },
    assignOpenModal:{
      type: Boolean
    },
    assignType: {
      type: String
    },

    dataObj: {}
  },
  watch: {
    assignOpen () {
      if (this.assignOpen === false) {
        this.$emit('assignclose', true)
      }
    }
  },
  created () {
    this.assignOpen = this.assignOpenModal
    this.customer_id = localStorage.getItem('customer_id')
  },
  mounted () {
    this.fetchStudentList()
    this.getCourseOptions()
    this.getTeacherList()

    console.log(this.formName)
    
    this.formType = this.formName ? this.formName.charAt(0).toUpperCase() + this.formName.slice(1) : ''

    if (this.assignType === 'reassign') {
      this.couseWorkPayload.title = this.dataObj.assignment_builder.title
      this.couseWorkPayload.has_deadline = this.dataObj.assignment_builder.has_deadline
      this.couseWorkPayload.has_submit_after_deadline = this.dataObj.assignment_builder.has_submit_after_deadline
      this.couseWorkPayload.deadline = this.dataObj.assignment_builder.deadline
      this.subjectlist = this.dataObj.assignment_builder.subject
      this.couseWorkPayload.assignment_type = this.dataObj.assignment_builder.assignment_type
      this.has_all_subject = this.dataObj.assignment_builder.has_all_subject
      this.selectedStudents = [this.dataObj.client_user]

    } else {
      this.subjectlist = this.dataObj.subject
    }
  },
  methods: {
    async funSearch (search) {
     
      try {
       this.name = search

        console.log(search)
        if (search != '') {

          this.teacherList = this.teacherList.filter((ele) => {
            if (ele.first_name.includes(search) || ele.last_name.includes(search)) {
              return ele
            }
          })

          if (this.teacherList.length == 0) {

            const payload = {
              ...this.filterPayload,
              name:this.name
            }
        
            const {data} = await fetchUserClient(
              'User',
              this.customer_id,
              {},
              payload
            )
            this.teacherList=data.data.users_list
            this.teacher_meta = data.data.meta
            this.teacher_meta.page = data.data.meta.current_page
          }
        }
      } catch (e) {
        //
      }
      
    },
    fetchtoSentenceCase () {
      return (this.assignType.charAt(0).toUpperCase() + this.assignType.slice(1))
    },
    async getTeacherList (search) {
      try {
        const payload = {
          ...this.filterPayload,
          name:search
        }

        const {data} = await fetchUserClient(
          'User',
          this.customer_id,
          this.teacher_meta,
          payload
        )
        this.teacherList = data.data.users_list
        this.teacher_meta = data.data.meta
        this.teacher_meta.page = data.data.meta.current_page
      } catch (e) {
        //
      }
    },
    detectsScrollLength () {
      if (Math.ceil(this.$refs.element.scrollTop + this.$refs.element.offsetHeight) >= this.$refs.element.scrollHeight) {
        this.loadMorestudents()
      }
    },
    async loadMorestudents () {
      try {
        const payload = {
          ...this.filterPayload
        }
        this.meta.page = this.meta.page + 1
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.meta,
          payload
        )
        this.studentlist.push(...data.data.data.users_list)
        this.meta = data.data.data.meta
        this.meta.page = data.data.data.meta.current_page
        if (this.assignType === 'reassign') {
          this.studentlist = this.studentlist.filter(ele => ele.client_users_id !== this.dataObj.client_user.client_users_id)
        }
      } catch (e) {
        //
      }
    },
    searchFun () {
      this.fetchStudentListByName(this)
    },
    fetchStudentListByName: _.debounce(async (vm) => {
      vm.meta.page = 1
      vm.fetchStudentList()

    }, 2000),
    async convertToCourseWork () {
      try {
        const users = []
        this.selectedStudents.forEach((ele) => {
          users.push(ele.client_users_id)
        })

        const payload = {
          subjects:
            this.filterPayload.subject_id.length > 0
              ? this.filterPayload.subject_id
              : [],
          has_all_subject:
            this.dataObj.has_all_subject ? this.dataObj.has_all_subject : this.has_all_subject,
          ...this.couseWorkPayload,
          users,
          assignment_builder_id:this.assignType === 'reassign' ? this.dataObj.assignment_builder.id : this.dataObj.id,
          is_reassigned:this.assignType === 'reassign'
        }
        if (payload.has_deadline && !payload.deadline) {
          return this.$vs.notify({
            title: 'Warning',
            text: 'Please select a deadline date',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }
        if (payload.has_deadline) {
          payload.deadline = `${payload.deadline  }:00`
        }
        
        
        if (payload.users.length === 0) {
          return this.$vs.notify({
            title: 'Warning',
            text: 'Please select at least one sturdent',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
            time: 3000
          })
        }

        await createCourseWork(payload, this.customer_id)
        this.$vs.notify({
          title: 'Success',
          text: `${this.formType} assigned successfully`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })

        this.$emit('assignclose', true)
        this.assignOpen = false

      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: 'Something went wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    async fetchStudentList () {
      try {
        const payload = {
          ...this.filterPayload,
          'active_user': 1
        }
        const data = await fetchUserClient(
          'Client',
          this.customer_id,
          this.meta,
          payload
        )
        this.studentlist = data.data.data.users_list
        this.meta = data.data.data.meta
        this.meta.page = data.data.data.meta.current_page
        if (this.assignType === 'reassign') {
          this.studentlist = this.studentlist.filter(ele => ele.client_users_id !== this.dataObj.client_user.client_users_id)
        }
      } catch (e) {
        //
      }
    },
    closeSelectedUser2 (index) {
      this.selectedStudents.splice(index, 1)
    },
    async getCourseOptions () {
      try {
        const payload = {
          subject_id: this.filterPayload.subject_id
        }
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload, this.course_list_meta
        )
        this.courseList = data.data.course_list

        this.course_list_meta = data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async onOpen () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observerCourse.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observerCourse.disconnect()
    },
    async onOpenTeacher () {
      if (this.teacher_meta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.loadTeacher)
      }
    },
    onCloseTeacher () {
      this.observer.disconnect()
    },
    async loadMoreCourses () {
      try {
        const payload = {
          subject_id: this.filterPayload.subject_id
        }
        this.course_list_meta.current_page = this.course_list_meta.current_page + 1
        const { data } = await shortCourseList(
          localStorage.getItem('customer_id'),
          payload, this.course_list_meta
        )
        this.courseList.push(...data.data.course_list)
        this.course_list_meta = data.data.meta
      } catch (e) {
        //
      }
    },
    async loadMoreTeacher ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          this.teacher_meta.page = this.teacher_meta.page + 1
          const payload = {
            ...this.filterPayload,
            name:this.name
          }
          const {data} = await fetchUserClient(
            'User',
            this.customer_id,
            this.teacher_meta,
            payload
          )
          this.teacherList =  this.teacherList.filter((ele) => {
            if (ele.users_id != data.data.users_list.map((item) => {
              return item.users_id
            
            })) return ele
          })
          this.teacherList.push(...data.data.users_list)
          this.teacher_meta = data.data.meta
          this.teacher_meta.page = data.data.meta.current_page
        } catch (e) {
          console.log(e)
        }
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    }
  }
}
</script>
